import nextCookie from 'next-cookies'
import { UserTokenLocal } from '@/src/types/api-types'
import LOCAL_STORAGE from '@/src/localstorage'

const getTokenFromCtx = ctx => {
  const cookie = nextCookie(ctx)

  return (
    (cookie?.[LOCAL_STORAGE.name_cookie_token] as UserTokenLocal) || {
      ttl: null,
      token: null,
      storefront_id: null,
      redirection_url: null,
      __typename: 'UserTokenLocal',
    }
  )
}

export default getTokenFromCtx
